import $ from 'jquery';

const doScroll = () => {
  $(window).on('load', () => {
    const scroll = $('.do-scroll');

    if (scroll.length) {
      $('body, html')
        .stop()
        .animate(
          {
            scrollTop: scroll.first().offset().top - 100,
          },
          500,
        );
    }
  });
};

export default doScroll();



// WEBPACK FOOTER //
// ./src/scripts/modules/do-scroll.js